import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'Group',
  props: {
  value: {
    type: [Object, String, Number],
    default: 0
  }
},
  emits: ["change"],
  setup(__props, { emit }: { emit: ({
  (e: 'change', state: any): void
}), expose: any, slots: any, attrs: any }) {





function setValue(value: any) {
  emit('change', value)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _renderSlot(_ctx.$slots, "options", {
      value: __props.value,
      setValue: setValue
    })
  ]))
}
}

})